import React, { FunctionComponent } from 'react'
import { useParams } from 'react-router-dom'
import styled from 'styled-components'
import { BannerImage } from '../components/banner-image'
import { ContentContainer } from '../components/content-container'
import { HeadBannar } from '../components/head-bannar'
import { PostNavigator } from '../components/post-navigator'
import { SideBar } from '../components/side-bar'
import { typebase } from '../css/typebase'
import { useNewsPostsQuery } from '../generated/graphql'
import { formatDate } from '../utils/format-date'
import { parseNumberOrNull } from '../utils/parse-number-or-null'
import { isNotNullish } from '../utils/type-check'
import { SideBarContainer, countByYearMonth, toYearMonth, Inner } from './news-list-page'

const Outer = styled.div``

export const PostInner = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  width: 100%;
`

const PostDate = styled.div`
  font-size: 0.8rem;
  color: #aaa;
  margin-bottom: 0.5rem;
`

const PostTitle = styled.div`
  font-weight: 700;
  line-height: 1.75;
  margin-bottom: 1rem;
`

export const PostContents = styled.div`
  padding: 2rem 0;
  margin: 2rem 0;
  border: solid #aaa;
  border-width: 1px 0;
  min-width: 0;
`
export const PostContentsInner = styled.div`
  font-size: 0.9rem;
  line-height: 2;
  ${typebase}
`

export const NavigatorContainer = styled.div`
  align-self: center;
`

type NewsPageProps = {

}
export const NewsPage: FunctionComponent<NewsPageProps> = () => {
  const params = useParams<'newsId'>()

  const newsPostsQuery = useNewsPostsQuery({variables: {
    first: 100000
  }})

  const targetId = parseNumberOrNull(params.newsId)
  const newsPost = targetId ? newsPostsQuery.data?.newsPosts?.nodes?.find(post => post?.news_postId === targetId) : null
  const postIndex = newsPostsQuery.data?.newsPosts?.nodes?.indexOf(newsPost) ?? null
  const nextPost = isNotNullish(postIndex) ? newsPostsQuery.data?.newsPosts?.nodes?.[postIndex + 1] ?? null : null
  const prevPost = isNotNullish(postIndex) ? newsPostsQuery.data?.newsPosts?.nodes?.[postIndex - 1] ?? null : null

  return null
  // return <Outer>
  //   <HeadBannar desktop={() => <BannerImage src="/images/header_09.jpg" />} mobile={() => <BannerImage src="/images/header_09_mobile.jpg" />}></HeadBannar>
  //   <ContentContainer>
  //     <Inner>
  //       <SideBarContainer>
  //         <SideBar archiveMap={new Map([
  //           ...countByYearMonth(newsPostsQuery.data?.newsPosts?.nodes?.map(news => news?.date ? new Date(news.date) : null).filter(isNotNullish) ?? [])
  //         ])} urlGenerator={(time => `/news?d=${toYearMonth(new Date(time))}`)}/>
  //       </SideBarContainer>
  //       <PostInner>
  //         {
  //           newsPost ? <>
  //             <PostDate>
  //               {formatDate(new Date(newsPost.date ?? NaN))}
  //             </PostDate>
  //             <PostTitle>
  //               {newsPost.title}
  //             </PostTitle>
  //             <PostContents>
  //               <PostContentsInner dangerouslySetInnerHTML={{__html: newsPost.content ?? ''}} />
  //             </PostContents>
  //           </> :
  //           '404 Not found'
  //         }
  //         <NavigatorContainer>
  //           <PostNavigator
  //             prevLink={prevPost ? `/news/${prevPost.news_postId}` : null}
  //             nextLink={nextPost ? `/news/${nextPost.news_postId}` : null}
  //             listLink="/news"
  //           />
  //         </NavigatorContainer>
  //       </PostInner>
  //     </Inner>
  //   </ContentContainer>
  // </Outer>
}